import { usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import { useLoginStateAsync } from '#src/app/shared/hooks/session';
import { isLoading } from '#src/app/shared/utils/async';

type Result = ModelHookResult<{
	enabled: boolean;
}>;

export function useSingleAddressFieldForUnauthenticated(): Result {
	const {
		data: {
			experiments: { petitionSignFormFullAddressCollectionRolloutVariation },
		},
	} = usePetitionDetailsPageUserData();

	const fullAddressCollectionEnabled = petitionSignFormFullAddressCollectionRolloutVariation === 'v1';

	const loginState = useLoginStateAsync();
	const isGuestOrIdentified = !isLoading(loginState) && ['GUEST', 'IDENTIFIED'].includes(loginState.value);

	return {
		data: {
			enabled: isGuestOrIdentified && fullAddressCollectionEnabled,
		},
	};
}
